import React from 'react';
import { Snackbar, IconButton } from '@mui/material';
import Slide, { SlideProps } from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';

interface NotificationProps {
  message: string;
  onClose?: () => void;
}

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

export const SimpleNotification: React.FC<NotificationProps> = ({
  message,
}) => {
  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );


  return (
    <Snackbar
      open={Boolean(message)}
      action={action}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={null}
      message={message}
      sx={(theme) => ({
        bottom: '20px !important',
        right: '20px !important',
        zIndex: 9999,
        '& .MuiSnackbarContent-root': {
          backgroundColor: theme.palette.primary.main,
        },
      })}
     />
  );
};